<template>
  <v-card height="100%">
    <project-flow-navigation-toolbar
      :title="projectName"
    ></project-flow-navigation-toolbar>
    <v-card-text style="height: calc(100% - 116px)">
      <new-manage-media></new-manage-media>
      <!-- <router-link
        style="text-decoration: none; color: inherit;"
        :to="{ name: 'Media Manager Edit Links' }"
      >
        <v-btn small color="primary darken-1">
          MANAGE PARENT LINKS
          <v-icon class="ml-1 text-subtitle-1">mdi-pencil</v-icon>
        </v-btn>
      </router-link> -->
    </v-card-text>
    <!-- <v-card-actions class="pl-5 pr-5 pb-4">
      <v-spacer></v-spacer>
      <v-btn small @click="cancel">Cancel</v-btn>
      <v-btn small color="primary darken-1" @click="save">Save</v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import ProjectFlowNavigationToolbar from '../components/AppBar/ProjectFlowNavigationToolbar'
import NewManageMedia from '../components/NewManageMedia'
export default {
  name: 'MediaManagerEdit',
  components: {
    ProjectFlowNavigationToolbar,
    NewManageMedia
  },
  mounted() {
    this.$store.dispatch(
      'BreadcrumbsStore/add',
      {
        text: 'MEDIA MANAGER ',
        name: 'Edit Media'
      },
      { root: true }
    )
  },
  methods: {
    save() {
      console.log('save')
    },
    cancel() {
      this.$router.go(-1)
    }
  },
  computed: {
    projectName: function() {
      return this.$store.state.ProjectStore.selectedProject
        ? this.$store.state.ProjectStore.selectedProject.name
        : ''
    }
  }
}
</script>

<style lang="css" scoped></style>
